
















import { Component, Watch, Mixins } from 'vue-property-decorator';
import AssetMixin from '@/assets/ts/mixins/AssetMixin';
import { findIndex } from 'lodash';
import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';
import Receive from '@/components/receive/Receive.vue';
import CustomDialog from '@/components/tools/CustomDialog.vue';
import ErrorDialog from '@/components/ErrorDialog.vue';
import { AssetState } from '@/assets/ts/model/AssetState';
import { EventBus, listeners } from '@/plugins/event-bus';
import { ErrorMessage } from '@/assets/ts/ErrorMessage';
import { constants } from 'fs';
import { MUTATE_MULTISIG_ACCOUNT} from '@/store';
import Notification from '@/components/notification/Notification.vue';
import { isTransferTransaction } from '@/assets/ts/tools/transaction/transactionTypeValidation';

@Component({
    components: {
        Header,
        Footer,
        CustomDialog,
        Receive,
        Notification,
        ErrorDialog,
    },
})

export default class App extends Mixins(AssetMixin) {
    public showReceive = false;
    public showCustomDialog = false;

    // error dialog properties
    public showErrorDialog = false;
    public errorMessage = '';

    public claimListenerIsOn = false;

    public assetListenerList: any[] = [];

    public mounted() {
        listeners.onAppMount.register(this);

        // if login then listening to user account
        if (this.auth.login) {
            // update multisig info of current account
            const account = {};
            this.mutateUserActivity(account);

            this.mutateMultisigAccounts();
            EventBus.$emit(listeners.onAppMount.events.LOGIN_LISTENER);
        }
    }

    public listenToClaim() {
        this.claimListenerIsOn = true;
        EventBus.$on('start-claim-listener', (asset: any) => {
            // check if listener for this asset has beed added or not
            const theIndex = findIndex(this.assetListenerList, (assetListener: any) => {
                return asset.equals(assetListener);
            });
            if (theIndex === -1) {
                // we need to add listener for this asset
            }

            EventBus.$emit('claim-listener-is-ready', asset);
        });
    }

    public validateClaimTransaction(tx: any, state: number) {
        if (this.auth.login) {
            if (this.isClaim(tx)) {
                this.storeAssetToMultisigAccounts(tx, state);
            }
        }
    }

    public isClaim(tx: any): boolean {
        const multisigAccount = {};

        if (tx) {
            const txModifications = tx.modifications;
            if (txModifications.length === 1) {
                    if (txModifications[0].type === 0) {
                            // if (txModifications[0].cosignatoryPublicAccount.publicKey
                            //     === this.auth.user.pb) {
                            //         return true;
                            // }
                            return false;
                    } else {
                            return false;
                    }
            } else {
                    return false;
            }
        } else {
                return false;
        }
    }

    public storeAssetToMultisigAccounts(tx: any, state: number) {
        const multisigAccount: any = {};

        const filteredMultisigAccount: any = {
            account: multisigAccount,
            state
        };

        this.$store.commit(MUTATE_MULTISIG_ACCOUNT, filteredMultisigAccount);
    }

    public mutateMultisigAccounts() {
        // TODO change this method to luxtag sdk
        // const accountHttp = new AccountHttp(this.$store.getters.getEndpoint);
        // const userAccount = PublicAccount.createFromPublicKey(this.auth.user.pb, NetworkType.MIJIN_TEST);
        // accountHttp.getMultisigAccountInfo(userAccount.address)
        //     .subscribe((multisigAccountInfo: MultisigAccountInfo) => {
        //         this.filterAndStoreAsset(multisigAccountInfo.multisigAccounts);
        //     }, (err) => {
        //         if (err.message === 'Not Found') {
        //             // empty multisig accounts
        //             this.filterAndStoreAsset([]);
        //         }
        //     });
    }

    public mutateUserActivity(account: any) {
        // const userHistory = new UserHistory(account);
        // userHistory.fetchAllTransactions().then((res: Transaction[]) => {
        //     this.$store.commit('MUTATE_ACTIVITIES', res);
        // }).catch((err: any) => {
        //     // error
        // });
    }

    public async isThisTxExistInArray(txList: any[], tx: any): Promise<boolean> {
        const theIndex = findIndex(txList, (cTx) => {
            return cTx.transactionInfo!.hash === tx.transactionInfo!.hash;
        });

        if (theIndex === -1) {
            return false;
        } else {
            return true;
        }
    }

    public initUserListener(account: any) {
        const txLisUnconfirmed: any[] = [];
        const txListConfirmed: any[] = [];

    }

    @Watch('isListenerOpen', { immediate: true })
    private onNem2ListenerOpenChange(val: boolean) {
        if (val) {
            if (this.auth.login) {
                const userAccount = {};
                this.initUserListener(userAccount);
            }
        }
    }

    get isListenerOpen() {
        return this.$store.getters.getListenerState;
    }

    get showNavigation(): any {
            return this.$store.getters.getShowFooter;
    }

    get socketEndpoint() {
        return this.$store.getters.getSocketEndpoint;
    }

    get auth() {
        return this.$store.getters.getAuth;
    }
}
